import { progressKey } from './identity.js';
import { lowerIsBetter, type EventDef, type EventId } from '@decathlon/shared';

const KEY = 'decathlon.pbs';
export type PersonalBests = Partial<Record<EventId, number>>;

export function loadPbs(): PersonalBests {
  try {
    return JSON.parse(localStorage.getItem(progressKey(KEY)) ?? '{}') as PersonalBests;
  } catch {
    return {};
  }
}

/** Record a mark; returns true if it is a new personal best. */
export function recordPb(ev: EventDef, mark: number): boolean {
  const pbs = loadPbs();
  const prev = pbs[ev.id];
  const better = prev === undefined || (lowerIsBetter(ev) ? mark < prev : mark > prev);
  if (better) {
    pbs[ev.id] = mark;
    try {
      localStorage.setItem(progressKey(KEY), JSON.stringify(pbs));
    } catch {
      /* ignore */
    }
  }
  return better;
}
